





















import { State, Action, Getter } from "vuex-class";
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import anime from "animejs";

@Component({})
export default class DesktopMenu extends Vue {
  @Prop({ default: 0 }) activeScreenNumber!: number;
  @Prop({ default: [] }) names!: string[];

  $refs!: {
    root: HTMLElement;
    activeBorder: HTMLElement;
  };

  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;
  @Getter("pageBehindAWindow") pageBehindAWindow!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  @Watch("loadingScreenActive")
  onLoadingScreenHide() {
    this.enterAnimation();
  }

  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (nextNumber == 0) {
      this.leaveAnimation();
    }

    this.setActiveBorderLinePosition();
  }

  activated() {
    if (!this.loadingScreenActive) {
      this.enterAnimation();
    }

    this.setActiveBorderLinePosition();
  }

  get screensNumber(): number {
    return this.names.length;
  }

  @Emit("screenChange")
  screenChange(number: number) {}

  click(screenNumber: number) {
    if (this.activeScreenNumber !== screenNumber) {
      this.screenChange(screenNumber);
    }
  }

  enterAnimation() {
    let items = this.$refs.root.querySelectorAll<HTMLElement>(
      ".desktop-menu__item"
    );
    anime({
      targets: items,
      duration: 900,
      left: ["-65%", "0%"],
      opacity: [0, 1],
      easing: "easeOutQuad",
      delay: (el: any, index: number) => {
        return 70 * index;
      }
    });
  }

  leaveAnimation() {
    let items = this.$refs.root.querySelectorAll<HTMLElement>(
      ".desktop-menu__item"
    );
    anime({
      targets: items,
      duration: 500,
      opacity: [1, 0],
      easing: "easeOutQuad",
      delay: (el: any, index: number) => {
        return 70 * index;
      }
    });
  }

  setActiveBorderLinePosition() {
    let activeElement = this.$refs.root.querySelectorAll<HTMLElement>(
      ".desktop-menu__item"
    )[this.activeScreenNumber - 1];
    if (activeElement != null) {
      if (activeElement.children.length < 1) return;
      let activeElementContent = activeElement.children[0] as HTMLElement;
      anime({
        targets: this.$refs.activeBorder,
        opacity: 1,
        top: activeElement.offsetTop,
        easing: "easeOutQuad",
        duration: 700,
        width: activeElementContent.offsetWidth,
        height: activeElementContent.offsetHeight
      });
    }
  }
}
